import React from "react";

// Define the component's props type
interface BenchLoaderProps {
  isLoading: boolean; // Indicates whether the loader should be visible
  loadingGif?: string; // Path to the loading GIF image
  width?: string; // Width of the loading GIF
  height?: string; // Height of the loading GIF
  message?: string; // Optional loading message
}

const BenchLoader: React.FC<BenchLoaderProps> = ({
  isLoading,
  loadingGif = require("../../../assets/loadinggif.gif"), // Default GIF
  width = "260px",
  height = "180px",
  message = "Loading, please wait...",
}) => {
  if (!isLoading) return null;

  return (
    <div
      className="bench-loader"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <img
          src={loadingGif}
          alt="Loading..."
          style={{
            width,
            height,
            marginBottom: "10px",
          }}
        />
        {/* {message && <p style={{ color: "white", fontSize: "18px" }}>{message}</p>} */}
      </div>
    </div>
  );
};

export default BenchLoader;
